import { AirCalendarList } from '@fcom/dapi/api/models/air-calendar-list';
import { FinnairAirCalendarChangeListResponse } from '@fcom/dapi/api/models/finnair-air-calendar-change-list-response';
import { FinnairCalendarChangeItineraryItem } from '@fcom/dapi/api/models/finnair-calendar-change-itinerary-item';
import { FinnairRequestItineraryItem } from '@fcom/dapi/api/models/finnair-request-itinerary-item';
import { isPresent } from '@fcom/core/utils/utils';

export const isBookingCalendarList = (
  calendarList: FinnairAirCalendarChangeListResponse | AirCalendarList
): calendarList is AirCalendarList =>
  calendarList && isPresent((calendarList as AirCalendarList).finnairSearchParameters);

export const isChangeItinerary = (
  itinerary: FinnairCalendarChangeItineraryItem[] | FinnairRequestItineraryItem[]
): itinerary is FinnairCalendarChangeItineraryItem[] => {
  return (itinerary as FinnairCalendarChangeItineraryItem[]).some((item) => isPresent(item.boundId));
};
